import { Field } from '@/isomorphic/components/forms/components/field';
import { validators } from '@/hooks/use-validation';
import { ApiUser } from './api-user';
import { FieldGroup } from './field-group';
import { PropsType, SignatoryType } from '../types';
import { useLocalization } from '@/hooks/use-localization';

type Props = {
    signatory: SignatoryType;
    showRequiredError?: boolean;
    getLabel: PropsType['getLabel'];
    onUpdate: (args: Partial<Pick<SignatoryType, 'phoneNumber' | 'email'>>) => void;
};

export const Signatory = ({ signatory, getLabel, onUpdate, showRequiredError = false }: Props) => {
    const { getLocale } = useLocalization();

    return (
        <div className="r-space-y-4 r-border-b r-border-b-gray-200 r-py-6">
            <ApiUser {...signatory} label={getLabel('companyPrincipal')} />
            <FieldGroup>
                <Field
                    grouped="top"
                    value={signatory.email}
                    label={getLabel('email')}
                    validation={value => validators.email(value)}
                    onChange={value => onUpdate({ email: value })}
                    showRequiredError={showRequiredError && !validators.email(signatory.email)}
                />
                <Field
                    grouped="bottom"
                    label={getLabel('phone')}
                    value={signatory.phoneNumber}
                    onChange={value => onUpdate({ phoneNumber: value })}
                    validation={value => validators.phoneMobile(value, getLocale())}
                    showRequiredError={showRequiredError && !validators.phoneMobile(signatory.phoneNumber, getLocale())}
                />
            </FieldGroup>
        </div>
    );
};
